import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {MessageStatus, TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-message-status',
    templateUrl: './message-status.component.html',
    styleUrls: ['./message-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageStatusComponent {
  @Input() messageStatus: TaskMessageStatus | MessageStatus;
  @Input() label: string;
  @Input() reason: string;
  @Input() header: string;
  @Input() showTooltip: boolean = true;
}
